/**
 * @description 登录、获取用户信息、退出登录、清除token逻辑，不建议修改
 */
import Vue from 'vue'
import {
  getUserInfo,
  login,
  logout,
  socialLogin,
  oauth2logout,
} from '@/api/user'
import cache from '@/utils/cache'
import { resetRouter } from '@/router'
import { isArray, isString } from '@/utils/validate'
import { title, tokenName, tokenTableName, authMode } from '@/config'

const state = () => ({
  token: cache.local.getItem(tokenTableName),
  empnmkj: '',
  avatar: 'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif',
  requestDestCd: '000001001',
  requestDestName: '協力会社',
  filename: '',
  userId: '',
  bizConnectionCdList: [],
})
const getters = {
  token: (state) => state.token,
  empnmkj: (state) => state.empnmkj,
  avatar: (state) => state.avatar,
  requestDestCd: (state) => state.requestDestCd,
  requestDestName: (state) => state.requestDestName,
  filename: (state) => state.filename,
  userId: (state) => state.userId,
  bizConnectionCdList: (state) => state.bizConnectionCdList,
}
const mutations = {
  /**
   * @description 设置token
   * @param {*} state
   * @param {*} token
   */
  setToken(state, token) {
    state.token = token
    cache.local.setItem({ name: tokenTableName, value: token })
  },
  /**
   * @description 设置用户名
   * @param {*} state
   * @param {*} empnmkj
   */
  setempnmkj(state, empnmkj) {
    state.empnmkj = empnmkj
  },
  /**
   * @description 设置头像
   * @param {*} state
   * @param {*} avatar
   */
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  setFileName(state, filename) {
    state.filename = filename
  },
  setRequestDestName(state, orgkjrn) {
    state.requestDestName = orgkjrn
  },
  setUserId(state, userId) {
    state.userId = userId
  },
  setBizConnectionCdList(state, bizConnectionCdList) {
    state.bizConnectionCdList = bizConnectionCdList.map((item) => {
      return item.bizConnectionCd
    })
  },
}
const actions = {
  /**
   * @description 登录拦截放行时，设置虚拟角色
   * @param {*} { commit, dispatch }
   */
  setVirtualRoles({ commit, dispatch }) {
    dispatch('acl/setFull', true, { root: true })
    commit('setAvatar', 'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif')
    commit('setempnmkj', 'admin')
  },
  /**
   * @description 登录
   * @param {*} { commit }
   * @param {*} userInfo
   */
  async login({ commit }, userInfo) {
    //const { [tokenName]: token } = await login(userInfo)
    const data = await login(userInfo)
    let token = data[tokenName]
    if (token) {
      commit('setToken', token)
      const hour = new Date().getHours()
      const thisTime =
        hour < 10
          ? 'お早うございます'
          : hour <= 18
          ? 'こんにちは'
          : 'こんばんは'
      Vue.prototype.$baseNotify(`${title}`, `${thisTime}ようこそ！`)
    } else {
      const err = `登録例外は発生しました, 正しく戻ってこない${tokenName}...`
      Vue.prototype.$baseMessage(err, 'error', 'vab-hey-message-error')
      throw err
    }
  },
  /**
   * @description 第三方登录
   * @param {*} {}
   * @param {*} tokenData
   */
  async socialLogin({ commit }, tokenData) {
    const {
      data: { [tokenName]: token },
    } = await socialLogin(tokenData)
    if (token) {
      commit('setToken', token)
      const hour = new Date().getHours()
      const thisTime =
        hour < 10
          ? 'お早うございます'
          : hour <= 18
          ? 'こんにちは'
          : 'こんばんは'
      Vue.prototype.$baseNotify(`${title}`, `${thisTime}ようこそ！`)
    } else {
      const err = `登録例外は発生しました, 正しく戻ってこない${tokenName}...`
      Vue.prototype.$baseMessage(err, 'error', 'vab-hey-message-error')
      throw err
    }
  },
  /**
   * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
   * @param {*} { commit, dispatch, state }
   * @returns
   */
  async getUserInfo({ commit, dispatch }) {
    const { empnmkj, avatar, roles, permissions, orgkjrn, empcd, orgs } =
      await getUserInfo()
    /**
     * 检验返回数据是否正常，无对应参数，将使用默认用户名,头像,Roles和Permissions
     * empnmkj {String}
     * avatar {String}
     * roles {List}
     * ability {List}
     */
    if (
      (empnmkj && !isString(empnmkj)) ||
      (avatar && !isString(avatar)) ||
      (roles && !isArray(roles)) ||
      (permissions && !isArray(permissions))
    ) {
      const err = 'getUserInfo核心接口异常，请检查返回JSON格式是否正确'
      Vue.prototype.$baseMessage(err, 'error', 'vab-hey-message-error')
      throw err
    } else {
      // 如不使用empnmkj用户名,可删除以下代码
      if (empnmkj) commit('setempnmkj', empnmkj)
      // 如不使用avatar头像,可删除以下代码
      if (avatar) commit('setAvatar', avatar)
      // 如不使用roles权限控制,可删除以下代码
      if (roles) dispatch('acl/setRole', roles, { root: true })
      if (orgkjrn) commit('setRequestDestName', orgkjrn)
      // 如不使用permissions权限控制,可删除以下代码
      if (permissions)
        dispatch('acl/setPermission', permissions, { root: true })
      if (empcd) commit('setUserId', empcd)
      if (orgs) commit('setBizConnectionCdList', orgs)
    }
  },
  /**
   * @description 退出登录
   * @param {*} { dispatch }
   */
  async logout({ dispatch }) {
    if (authMode == 'normal') {
      await logout().catch(() => {})
    } else {
      await oauth2logout().catch(() => {})
    }
    await dispatch('resetAll')
  },
  /**
   * @description 重置token、roles、permission、router、tabsBar等
   * @param {*} { commit, dispatch }
   */
  async resetAll({ commit, dispatch }) {
    commit('setempnmkj', 'admin')
    commit('routes/setRoutes', [], { root: true })
    commit('setBizConnectionCdList', [])
    await dispatch('setToken', '')
    await dispatch('acl/setFull', false, { root: true })
    await dispatch('acl/setRole', [], { root: true })
    await dispatch('acl/setPermission', [], { root: true })
    await dispatch('tabs/delAllVisitedRoutes', null, { root: true })
    await resetRouter()
    cache.local.remove(tokenName)
  },
  /**
   * @description 设置token
   * @param {*} { commit }
   * @param {*} token
   */
  setToken({ commit }, token) {
    commit('setToken', token)
  },
  /**
   * @description 设置头像
   * @param {*} { commit }
   * @param {*} avatar
   */
  setAvatar({ commit }, avatar) {
    commit('setAvatar', avatar)
  },
  setFileName({ commit }, filename) {
    commit('setFileName', filename)
  },
}
export default { state, getters, mutations, actions }
